



































































































import { Component, Vue, Prop } from 'vue-property-decorator'

import { Url } from '../../../type'
import { User } from '../../../store/user/types'
import FeatureType from '../../../lib/masters/FeatureType'
import Feature from '../../../lib/masters/Feature'
import SpecialtyType from '../../../lib/masters/SpecialtyType'
import Specialty from '../../../lib/masters/Specialty'
import UserTransitionDialog from './UserTransitionDialog.vue'

@Component({ components: { UserTransitionDialog } })
export default class UserDetailDialog extends Vue {
  @Prop() value!: boolean
  @Prop() user!: User
  showTransitionConfirm = false

  get fullName() {
    return `${this.user.familyName} ${this.user.firstName}`
  }

  toSpecialtyText(type: SpecialtyType) {
    return Specialty[type].text
  }

  toSpecialtyColor(type: SpecialtyType) {
    return type === SpecialtyType.Insurance
      ? 'green'
      : type === SpecialtyType.RealEstate
      ? 'pink'
      : 'cyan'
  }

  toFeatureText(type: FeatureType) {
    return Feature[type].text
  }

  toFacilityText(type: FeatureType) {
    return Feature[type].text
  }

  handleSelectUser() {
    this.showTransitionConfirm = true
  }

  handleAcceptTransition() {
    window.open(Url.LineTransition, '_blank')
    this.showTransitionConfirm = false
  }
}
